import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiButton } from '@taiga-ui/core';

import { SettingsButtonComponent } from './settings-button.component';

@NgModule({
  declarations: [SettingsButtonComponent],
  imports: [CommonModule, TuiButton, RouterModule],
  exports: [SettingsButtonComponent],
})
export class SettingsButtonModule {}
